import { render } from "./DomainEdit.vue?vue&type=template&id=be72de14"
import script from "./DomainEdit.vue?vue&type=script&lang=js"
export * from "./DomainEdit.vue?vue&type=script&lang=js"

import "./DomainEdit.vue?vue&type=style&index=0&id=be72de14&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__